"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserIndicator = void 0;

var react_1 = __importDefault(require("react"));

var theme_ui_1 = require("theme-ui");

var icons_1 = require("../icons");

var auth_1 = require("../auth");

function UserIndicator() {
  var user = auth_1.useGetUser();
  return react_1.default.createElement(theme_ui_1.Link, {
    href: "https://roam.garden/user",
    target: "_blank",
    sx: styles.loginBtn
  }, react_1.default.createElement(theme_ui_1.Box, {
    sx: {
      marginRight: "0.2em"
    }
  }, react_1.default.createElement(icons_1.UserIcon, null)), user);
}

exports.UserIndicator = UserIndicator;
var styles = {
  loginBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: '15px',
    color: '#0F2137',
    fontWeight: 500,
    mr: '20px',
    img: {
      mr: '9px'
    }
  }
};